/**
 * Constants for Dining & Services CMS
 */

export const MENU_CATEGORIES = [
    { value: 'starter', label: 'Starter' },
    { value: 'main', label: 'Main Course' },
    { value: 'dessert', label: 'Dessert' },
    { value: 'side', label: 'Side' },
    { value: 'beverage', label: 'Beverage' },
    { value: 'special', label: "Chef's Special" }
];

export const SERVICE_CATEGORIES = [
    { value: 'housekeeping', label: 'Housekeeping' },
    { value: 'maintenance', label: 'Maintenance' },
    { value: 'transport', label: 'Transport' },
    { value: 'hair_beauty', label: 'Hair & Beauty' },
    { value: 'parcels', label: 'Parcels' },
    { value: 'other', label: 'Other' }
];

export const REQUEST_STATUSES = [
    { value: 'submitted', label: 'Submitted', color: 'bg-amber-100 text-amber-700' },
    { value: 'acknowledged', label: 'Acknowledged', color: 'bg-blue-100 text-blue-700' },
    { value: 'in_progress', label: 'In Progress', color: 'bg-purple-100 text-purple-700' },
    { value: 'completed', label: 'Completed', color: 'bg-green-100 text-green-700' },
    { value: 'cancelled', label: 'Cancelled', color: 'bg-gray-100 text-gray-500' }
];

export const RESERVATION_STATUSES = [
    { value: 'pending', label: 'Pending', color: 'bg-amber-100 text-amber-700' },
    { value: 'confirmed', label: 'Confirmed', color: 'bg-green-100 text-green-700' },
    { value: 'cancelled', label: 'Cancelled', color: 'bg-gray-100 text-gray-500' }
];

// Utility functions
export const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'short', 
        year: 'numeric'
    });
};

export const formatDateTime = (dateStr) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleString('en-GB', { 
        day: 'numeric', 
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const getStatusColor = (status, type) => {
    const statuses = type === 'reservation' ? RESERVATION_STATUSES : REQUEST_STATUSES;
    return statuses.find(s => s.value === status)?.color || 'bg-gray-100 text-gray-600';
};

export const getPriorityColor = (priority) => {
    const colors = {
        urgent: 'bg-red-100 text-red-700',
        high: 'bg-orange-100 text-orange-700',
        normal: 'bg-gray-100 text-gray-600',
        low: 'bg-blue-100 text-blue-700'
    };
    return colors[priority] || colors.normal;
};
